import type { ArticleItem } from "@/mocks/news";

interface ArticleCardProps {
  article: ArticleItem;
  active?: boolean;
  onSelect: (article: ArticleItem) => void;
}

export default function ArticleCard({ article, active, onSelect }: ArticleCardProps) {
  return (
    <article
      className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
        active ? "border-primary-400" : "border-background-200 hover:border-primary-300"
      }`}
    >
      <button
        type="button"
        onClick={() => onSelect(article)}
        className="group flex h-full w-full flex-col text-left"
      >
        <div className="relative aspect-[4/3] w-full overflow-hidden">
          <img
            src={article.cover}
            alt={`${article.title} — ${article.category}爆料配图`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
          />
          <div className="absolute left-3 top-3 flex flex-wrap gap-1.5">
            {article.exclusive && (
              <span className="rounded-md bg-primary-500 px-2 py-1 text-[11px] font-medium text-background-50">
                独家首发
              </span>
            )}
            {article.hot && (
              <span className="rounded-md bg-secondary-500 px-2 py-1 text-[11px] font-medium text-secondary-950">
                热度上升
              </span>
            )}
          </div>
        </div>

        <div className="flex flex-1 flex-col p-4">
          <div className="flex items-center gap-2 text-xs">
            <span className="rounded bg-accent-100 px-2 py-0.5 font-medium text-accent-900">
              {article.category}
            </span>
            <span className="text-foreground-500">{article.publishedAt}</span>
          </div>
          <h3 className="mt-2.5 line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950">
            {article.title}
          </h3>
          <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
            {article.excerpt}
          </p>
          <div className="mt-auto flex items-center gap-3 pt-4 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line" aria-hidden />
              {article.reads}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-chat-3-line" aria-hidden />
              {article.comments}
            </span>
            <span className="ml-auto flex items-center gap-1 text-primary-600">
              <i className="ri-time-line" aria-hidden />
              {article.status}
            </span>
          </div>
        </div>
      </button>
    </article>
  );
}